import React, { useState, useEffect, useRef, useContext } from "react";
import "./Fakture.css";
import { Button } from "primereact/button";
import NovaDevizna from "./IzlazneFakture/NovaDevizna";
import NovaDinarska from "./IzlazneFakture/NovaDinarska";
import PregledFaktura from "./IzlazneFakture/PregledFaktura";
import PregledPredracuna from "./IzlazneFakture/PregledPredracuna";
import OveraFaktura from "./IzlazneFakture/OveraFaktura";
import NovaDokumentKOKZ from "./IzlazneFakture/NovaDokumentKOKZ";
import PregledDokumenataKOKZ from "./IzlazneFakture/PregledDokumenataKOKZ";
import ProveraDokumenataKOKZ from "./IzlazneFakture/ProveraDokumenataKOKZ";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import usePermission from "../../custom/usePermission";
import { useTranslation } from "react-i18next";
import { AuthContext } from "../../Header/auth - context";
import { Toast } from "primereact/toast";

const Izlazne_fakture = () => {
  const [changeView, setChangeView] = useState(null);
  const [formKey, setFormKey] = useState(0);
  const toast = useRef(null);
  const auth = useContext(AuthContext);
  const dispatch = useDispatch();
  const activeClass = "activeButton";
  const company = useSelector((state) => state.company);
  const user = useSelector((state) => state.user);
  const role = useSelector((state) => state.user_role);
  const eskaliran = useSelector((state) => state.eskaliran);
  const { can } = usePermission();
  const { t } = useTranslation();
  const countAvansAlarm = useSelector((state) => state.countAvansAlarm || 0);
  const countInvoiceToCheck = useSelector((state) => state.countInvoiceToCheck || 0);
  const location = useLocation();
  /* `idOtpremnica` stiže iz Magacina („Unesi fakturu" na otpremnici) —
     isti mehanizam kao `idWorkLog` sa radnog naloga, samo drugi dokument. */
  const { idWorkLog, idServis, idOtpremnica } = location.state || {};
  const [podTipFakture, setPodTipFakture] = useState(null);
  const [idDrzava, setIdDrzava] = useState(null);
  const [idInvoice, setIdInvoice] = useState(null);
  const [idPredracunZaKonacni, setIdPredracunZaKonacni] = useState(null);
  const [idDokument, setIdDokument] = useState(null);
  const [koKzView, setKoKzView] = useState(1);
  const [klijentiOptions, setKlijentiOptions] = useState([]);
  const [vrstaFaktureOptions, setVrstaFaktureOptions] = useState([]);
  const [magacinOptions, setMagacinOptions] = useState([]);
  /* Artikli — stavka fakture iz magacina nosi artikal. */
  const [artikalOptions, setArtikalOptions] = useState([]);
  const [vozilaOptions, setVozilaOptions] = useState([]);
  const [tekuciRacunOptions, setTekuciRacunOptions] = useState([]);
  const [kurseviOptions, setKurseviOptions] = useState([]);
  const [drzaveOptions, setDrzaveOptions] = useState([]);
  const [valutaOptions, setValutaOptions] = useState([]);
  const [referentiOptions, setReferentiOptions] = useState([]);
  const [grupaFaktureOptions, setGrupaFaktureOptions] = useState([]);
  const [sifraStavkeOptions,setSifraStavkeOptions] = useState([]);
  const [jedinicaMereOptions, setJedinicaMereOptions] = useState([]);
  const [tripSelected, setTripSelected] = useState([]);
  const [otpremnicaSelected, setOtpremnicaSelected] = useState([]);
  const [finansijskiStatusOptions, setFinansijskiStatusOptions] = useState([]);
  const [statusSefaOptions, setStatusSefaOptions] = useState([]);

  const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

  useEffect( () => {

    let requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + auth.token,
      },
      body: JSON.stringify({
        tip: 'IZ',
        id: idServis || idWorkLog || idOtpremnica,
        izvor: idOtpremnica ? 'OTPREMNICA' : 'RADNI_NALOG',
      }),
    };

    fetch(
      process.env.REACT_APP_BACKEND_URL + "/invoice/GetInvoicesAndTypes",
      requestOptions
    )
      .then(handleErrors)
      .then((data) => {
        setKlijentiOptions(data?.ClientsDB);
        setVrstaFaktureOptions(data?.VrstaFakture);
        setMagacinOptions(data?.MagacinDB);
        setArtikalOptions(data?.ArtikliDB || []);
        setVozilaOptions(data?.VozilaDB);
        setTekuciRacunOptions(data?.Accounts);
        setKurseviOptions(data?.Kursevi);
        setDrzaveOptions(data?.DrzaveDB);
        setValutaOptions(data?.ValuteDB);
        setReferentiOptions(data?.Referenti);
        setSifraStavkeOptions(data?.SifreDB);
        setJedinicaMereOptions(data?.JediniceMereDB);
        setGrupaFaktureOptions(data?.GroupInvoice);
        setPodTipFakture(data?.isDinarska ? 305 : 306);
        setTripSelected(data?.Trip);
        setOtpremnicaSelected(data?.Otpremnica || []);
        setFinansijskiStatusOptions(data?.FinansijskiStatusDB);
        setStatusSefaOptions(data?.StatusSefaDB);


        if(data?.isDinarska) {
            setChangeView(1)
        }
        else
        setChangeView(2)

        setIdDrzava(data?.idDrzava);
      })
      .catch((error) => {
        error.json().then((errorMessage) => {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: errorMessage.message,
            life: 3000,
          });
          console.log(errorMessage);
        });
      });


  }, []);    

useEffect(() => {
  return () => {
    setIdInvoice(null);
    setIdPredracunZaKonacni(null);
  };
}, [location.key]);

// Učitaj alarm count za predračune bez konačnog
const fetchAvansAlarm = () => {
  fetch(process.env.REACT_APP_BACKEND_URL + '/invoice/GetAvansAlarmCount', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
  })
    .then(r => r.json())
    .then(data => {
      const count = data?.[0]?.AlarmCount || 0;
      dispatch({ type: 'AVANS_ALARM_SET', value: count });
    })
    .catch(() => {});
};

useEffect(() => {
  if (auth.token) fetchAvansAlarm();
}, [auth.token, company.companyId]);

  return (
    <div className="Izlazne_fakture">
      {idDrzava === 1 && <Button
        id={changeView == 1 && activeClass}
        label={t('fakture.novaDinarska')}
        className="mt-3 zaposleniShift"
        style={{fontSize: 'smaller'}}
        onClick={() => {
          setChangeView(1);
          setIdInvoice(null);
          setIdPredracunZaKonacni(null);
          setTripSelected([]);
          setFormKey(k => k + 1);
        }}
      />}
      <Button
        id={changeView == 2 && activeClass}
        label={t('fakture.novaDevizna')}
        className="mt-3 zaposleniShift"
        style={{fontSize: 'smaller'}}
        onClick={() => {
          setChangeView(2);
          setIdInvoice(null);
          setIdPredracunZaKonacni(null);
          setTripSelected([]);
          setFormKey(k => k + 1);
        }}
      />
      <Button
        id={changeView == 6 && activeClass}
        label={t('fakture.dokumentiKoKz')}
        className="mt-3 zaposleniShift"
        style={{fontSize: 'smaller'}}
        onClick={() => {
          setChangeView(6);
          setIdInvoice(null);
          setIdDokument(null);
          setKoKzView(idDrzava === 1 ? 1 : 2);
        }}
      />
      <Button
        id={changeView == 3 && activeClass}
        label={t('fakture.pregledFaktura')}
        className="mt-3 zaposleniShift"
        style={{fontSize: 'smaller'}} 
        onClick={() => {
          setChangeView(3);
          if(changeView != 3)
          setIdInvoice(null)
        }}
      />
      <div style={{ position: 'relative', display: 'inline-flex' }}>
        <Button
          id={changeView == 4 && activeClass}
          label={t('fakture.pregledPredracuna')}
          className="mt-3 zaposleniShift"
          style={{fontSize: 'smaller'}}
          onClick={() => {
            setChangeView(4);
            if(changeView != 4) setIdInvoice(null);
          }}
        />
        {countAvansAlarm > 0 && (
          <span className="sidebar-link-badge badge-blue" style={{ position: 'absolute', top: '-2px', right: '-6px', zIndex: 1 }}>
            {countAvansAlarm > 99 ? '99+' : countAvansAlarm}
          </span>
        )}
      </div>
      {can('FAKTURE', 'edit') && (
        <div style={{ position: 'relative', display: 'inline-flex' }}>
          <Button
            id={changeView == 5 && activeClass}
            label={t('fakture.proveraFaktura')}
            className="mt-3 zaposleniShift"
            style={{fontSize: 'smaller'}}
            onClick={() => {
              setChangeView(5);
              if(changeView != 5) setIdInvoice(null);
            }}
          />
          {countInvoiceToCheck > 0 && (
            <span className="sidebar-link-badge badge-blue" style={{ position: 'absolute', top: '-2px', right: '-6px', zIndex: 1 }}>
              {countInvoiceToCheck > 99 ? '99+' : countInvoiceToCheck}
            </span>
          )}
        </div>
      )}
        <Toast ref={toast} />
      {changeView === 1 && company.companyState == 'Srbija' ? (
        <NovaDinarska
          key={formKey}
          podTipFakture={305}
          idDrzava={idDrzava}
          klijentiOptions={klijentiOptions}
          vrstaFaktureOptions={vrstaFaktureOptions}
          magacinOptions={magacinOptions}
          artikalOptions={artikalOptions}
          vozilaOptions={vozilaOptions}
          kurseviOptions={kurseviOptions}
          tekuciRacunOptions={tekuciRacunOptions}
          drzaveOptions={drzaveOptions}
          valutaOptions={valutaOptions}
          sifraStavkeOptions={sifraStavkeOptions}
          jedinicaMereOptions={jedinicaMereOptions}
          referentiOptions={referentiOptions}
          grupaFaktureOptions={grupaFaktureOptions}
          tripSelected={tripSelected}
          otpremnicaSelected={otpremnicaSelected}
          tipFakture={303}
          valutaOpcija={220}
          idInvoice={idInvoice}
          setIdInvoice={setIdInvoice}
          setChangeView={setChangeView}
          changeView={changeView}
          finansijskiStatusOptions={finansijskiStatusOptions}
          statusSefaOptions={statusSefaOptions}
          idPredracunZaKonacni={idPredracunZaKonacni}
          setIdPredracunZaKonacni={setIdPredracunZaKonacni}
        />
      ) : null}
      {changeView == 2 && <NovaDevizna
          key={formKey}
          podTipFakture={306}
          idDrzava={idDrzava}
          klijentiOptions={klijentiOptions}
          vrstaFaktureOptions={vrstaFaktureOptions}
          magacinOptions={magacinOptions}
          artikalOptions={artikalOptions}
          vozilaOptions={vozilaOptions}
          kurseviOptions={kurseviOptions}
          tekuciRacunOptions={tekuciRacunOptions}
          drzaveOptions={drzaveOptions}
          valutaOptions={valutaOptions}
          sifraStavkeOptions={sifraStavkeOptions}
          jedinicaMereOptions={jedinicaMereOptions}
          referentiOptions={referentiOptions}
          grupaFaktureOptions={grupaFaktureOptions}
          tripSelected={tripSelected}
          otpremnicaSelected={otpremnicaSelected}
          tipFakture={303}
          valutaOpcija={186}
          idInvoice={idInvoice}
          setIdInvoice={setIdInvoice}
          setChangeView={setChangeView}
          changeView={changeView}
          finansijskiStatusOptions={finansijskiStatusOptions}
          idPredracunZaKonacni={idPredracunZaKonacni}
          setIdPredracunZaKonacni={setIdPredracunZaKonacni}
          />}
      {changeView == 3 && <PregledFaktura setIdInvoice={setIdInvoice} setChangeView={setChangeView} />}
      {changeView == 4 && <PregledPredracuna setIdInvoice={setIdInvoice} setChangeView={setChangeView} setIdPredracunZaKonacni={setIdPredracunZaKonacni} />}
      {changeView == 5 && <OveraFaktura setIdInvoice={setIdInvoice} setChangeView={setChangeView} />}

      {changeView == 6 && (
        <div style={{ width: '100%' }}>
          <div style={{ marginTop: '0.5rem', marginBottom: '0.5rem', display: 'flex', flexWrap: 'wrap', gap: '0.3rem' }}>
            {idDrzava === 1 && (
              <Button
                id={koKzView === 1 ? activeClass : undefined}
                label={t('fakture.noviDinarski')}
                className="zaposleniShift"
                style={{ fontSize: 'smaller' }}
                onClick={() => { setKoKzView(1); setIdDokument(null); }}
              />
            )}
            <Button
              id={koKzView === 2 ? activeClass : undefined}
              label={t('fakture.noviDevizni')}
              className="zaposleniShift"
              style={{ fontSize: 'smaller' }}
              onClick={() => { setKoKzView(2); setIdDokument(null); }}
            />
            <Button
              id={koKzView === 3 ? activeClass : undefined}
              label={t('fakture.pregled')}
              className="zaposleniShift"
              style={{ fontSize: 'smaller' }}
              onClick={() => setKoKzView(3)}
            />
            {can('FAKTURE', 'edit') && (
              <Button
                id={koKzView === 4 ? activeClass : undefined}
                label={t('fakture.provera')}
                className="zaposleniShift"
                style={{ fontSize: 'smaller' }}
                onClick={() => setKoKzView(4)}
              />
            )}
          </div>

          {koKzView === 1 && idDrzava === 1 && (
            <NovaDokumentKOKZ
              key={idDokument || 'new-din'}
              isDinarska={true}
              klijentiOptions={klijentiOptions}
              valutaOptions={valutaOptions}
              kurseviOptions={kurseviOptions}
              tekuciRacunOptions={tekuciRacunOptions}
              sifraStavkeOptions={sifraStavkeOptions}
              jedinicaMereOptions={jedinicaMereOptions}
              statusSefaOptions={statusSefaOptions}
              vozilaOptions={vozilaOptions}
              idDokument={idDokument}
              setIdDokument={setIdDokument}
            />
          )}
          {koKzView === 2 && (
            <NovaDokumentKOKZ
              key={idDokument || 'new-dev'}
              isDinarska={false}
              klijentiOptions={klijentiOptions}
              valutaOptions={valutaOptions}
              kurseviOptions={kurseviOptions}
              tekuciRacunOptions={tekuciRacunOptions}
              sifraStavkeOptions={sifraStavkeOptions}
              jedinicaMereOptions={jedinicaMereOptions}
              statusSefaOptions={statusSefaOptions}
              vozilaOptions={vozilaOptions}
              idDokument={idDokument}
              setIdDokument={setIdDokument}
            />
          )}
          {koKzView === 3 && (
            <PregledDokumenataKOKZ
              setIdDokument={setIdDokument}
              setKoKzView={setKoKzView}
            />
          )}
          {koKzView === 4 && (
            <ProveraDokumenataKOKZ
              setIdDokument={setIdDokument}
              setKoKzView={setKoKzView}
            />
          )}
        </div>
      )}
    </div>
  );
};
export default Izlazne_fakture;
